/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Display_Save_SettingsInputs */



/**
* | output |
* | --- |
* | "Save Settings" |
*
* @param {Options_Display_Save_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_display_save_settings = /** @type {((inputs?: Options_Display_Save_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Display_Save_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer les paramètres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungen speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva impostazioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохраните настройки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar configuración")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("設定を保存")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेटिंग्स सेव करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar configurações")
	return /** @type {LocalizedString} */ ("Save Settings")
});